import { NullableValue } from '../../../../../types/common/util';
import { UserPermissionType } from '../../../../../types/common/PermissionType';

export type AccountAdminCreateErrorResponse = {
  code: string;
  message: string;
};

export type AccountAdminCreateRequest = {
  email: string;
  password: string;
  name: string;
  phone: string;
  level: number;
  status: string;
  permission: UserPermissionType;
};

export type AccountAdminCreateResponse = {
  status: number;
  data: {
    id: number;
    email: string;
    name: string;
    phone: string;
    level: number;
    createDate: string;
    updateDate: string;
  };
};

export type AccountAdminEditRequest = {
  password?: string;
  name?: string;
  level?: number;
  status?: string;
  permission?: UserPermissionType;
};

export enum FormMode {
  CREATE = 'create',
  DETAIL = 'detail',
  EDIT = 'edit',
}

export type AccountAdminInfoResponse = {
  data: {
    id: number;
    email: string;
    name: string;
    level: number;
    status: string;
    createDate: string;
    updateDate: string;
    permission: UserPermissionType;
  };
};

export type AdminInfoType = {
  id: number;
  email: string;
  name: string;
  level: number;
  status: string;
  createDate: string;
  updateDate: string;
};

export type AccountAdminEditPayload = {
  id: number;
  data: AccountAdminEditRequest;
};

export type AccountAdminInfoRequest = {
  id: string;
};

export type AccountAdminInfoErrorResponse = {
  code: string;
  message: string;
};

export type AccountAdminListQueryParamType = NullableValue<{
  sortBy?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
  id?: string;
  email?: string;
  name?: string;
}>;

export type AccountAdminListResponse = {
  data: Array<AccountAdminInfoResponse[]>;
  total: number;
};

export type FilterOption = NullableValue<{
  id?: string;
  email?: string;
  name?: string;
  level?: string;
  status?: string;
}>;

export type PaginationOption = {
  pageIndex: number;
  pageSize: number;
};
